export default __webpack_public_path__ + "static/media/saudi-man-login-page.266bb911.webp";